import defaultWebError from '#themes/default/web/components/error/error.js';

import cButton from '#themes/avast/web/components/button/button.js';
import cHeader from '#themes/avast/web/components/header/header.js';

export default {
	components: {
		cButton,
		cHeader
	},
	extends: defaultWebError
};
